<template>
    <div id="post-immo">
        <!--            Informations principales -->
        <div v-show="currentTab === 'main'">
            <ubi-panel>
                <!--DEBUT Cas CMIste-->
                <el-container>
                    <el-aside width="30%">
                        <h3>{{ $t('posts.edit.mainInformationTitle') }}</h3>
                        <p class="text-justify" v-html="$t('posts.edit.mainInformationText')"/>

                        <em class="el-icon-check" v-if="post.titre != null && post.titre.length > 1"></em>
                        <em class="el-icon-close red" v-if="post.titre == null || post.titre.length <= 1"></em>
                        {{ $t('posts.edit.title') }}
                        <br/>
                        <em class="el-icon-check" v-if="post.prix > 0"></em>
                        <em class="el-icon-close red" v-if="post.prix == null ||  post.prix.length <= 1"></em>
                        {{ $t('posts.edit.price') }}
                        <br/>
                        <em class="el-icon-check" v-if="post.texte != null && post.texte.length > 10"></em>
                        <em class="el-icon-close red" v-if="post.texte == null ||  post.texte.length <= 10"></em>
                        {{ $t('posts.edit.description') }}
                        <br/>
                        <br/>
                        <br/>
                    </el-aside>
                    <el-main>

                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item :label="$t('posts.edit.title') + ' *'" prop="titre">
                                    <el-input v-model="post.titre"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="10">
                                <el-form-item :label="$t('posts.edit.price') + ' *'" prop="prix">
                                    <el-input autocomplete="off" type="prix" v-model.number="post.prix">
                                        <div slot="append">{{getDevise}}</div>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item :label="$labels.devise_iso_4217">
                                    <el-select
                                            v-model="post.devise_iso_4217"
                                            @change="deviseSelect(post.devise_iso_4217)"
                                            :value="valueDevise"
                                            filterable
                                            default-first-option
                                    >
                                        <el-option
                                                style="text-transform:capitalize"
                                                v-for="deviseChoice in this.getChoices('devise_iso_4217')"
                                                :key="deviseChoice"
                                                :label="deviseChoice"
                                                :value="deviseChoice"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">

                            <el-col :span="7">
                                <el-form-item :label="$labels.afficher_prix + ' *'" prop="afficher_prix" icon="el-icon-question">
                                    <el-radio label="oui" v-model="post.afficher_prix">{{ $t("general.yes") }}</el-radio>
                                    <el-radio label="non" v-model="post.afficher_prix">{{ $t("general.no") }}</el-radio>
                                </el-form-item>

                            </el-col>
                            <el-col :span="12">
                                <el-tooltip placement="top-start" :content="$t('posts.edit.showPriceTooltip')">
                                    <em class="el-icon-question"></em>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item :label="$t('posts.edit.adText') + ' *'" prop="texte">
                                    <el-input :rows="5" type="textarea" v-model="post.texte"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24"  v-if="isARLOGIS">
                                <el-form-item label="Description courte">
                                    <el-input
                                            :rows="2"
                                            type="textarea"
                                            v-model="post.texte_resume"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="post.typeObjet >= 1200 && post.typeObjet < 1300">
                                <el-form-item :label="$labels.surface_habitable"
                                              prop="surface_habitable"
                                >
                                    <el-input type="number" step="0.01" v-model="post.surface_habitable">
                                        <template slot="append">m²</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="post.typeObjet >= 1200 && post.typeObjet < 1300">
                                <el-form-item :label="$labels.marque_maison">
                                    <el-input v-model="post.marque_maison">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="post.typeObjet >= 1200 && post.typeObjet < 1300">
                                <el-form-item :label="$labels.gamme_modele_maison">
                                    <el-input v-model="post.gamme_modele_maison">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="post.typeObjet == 1310">
                                <el-form-item :label="$labels.surface_terrain"
                                              prop="surface_terrain"
                                >
                                    <el-input v-model.number="post.surface_terrain" type="surface_terrain_a_batir">
                                        <div slot="append">m²</div>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-main>
                </el-container>
                <!--FIN Cas CMIste-->

            </ubi-panel>

            <ubi-panel v-if="currentType == 'terrain'">
                <!-- Classic case-->
                <el-container>
                    <el-aside width="30%">
                        <h3>{{ $t("posts.edit.locationPropertyTitle") }}</h3>
                        <p class="text-justify" v-html="$t('posts.edit.locationPropertyText')"/>
                    </el-aside>
                    <el-main>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <h4>{{ $t("posts.edit.exactAddressTitle") }}</h4>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item :label="$labels.pays" prop="pays">
                                    <el-select
                                            v-model="paysValue"
                                            filterable
                                            clearable
                                            default-first-option
                                            @change="selectPays"
                                    >
                                        <el-option
                                                :key="pays.libelle"
                                                :label="pays.translated_name"
                                                :value="pays.libelle"
                                                v-for="pays in getCountries"
                                        />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :md="12" :xs="24">
                                <el-form-item :label="$labels.code_postal + ' *'" prop="code_postal_reel">
                                    <el-autocomplete
                                            class="inline-input"
                                            v-model="post.code_postal_reel"
                                            :fetch-suggestions="searchPostal"
                                            @select="selectPostalReel"></el-autocomplete>
                                </el-form-item>
                            </el-col>
                            <el-col :md="12" :xs="24">
                                <el-form-item :label="$labels.ville + ' *'" prop="ville_reelle">
                                    <el-input v-model="post.ville_reelle"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :md="6" :xs="24">
                                <el-form-item :label="$labels.numero_voie" prop="numero_voie">
                                    <el-input v-model.number="post.numero_voie"></el-input>
                                </el-form-item>
                            </el-col>
                            <div v-if="isARLOGIS">
                                <el-col :md="6" :xs="24">
                                    <el-form-item :label="$labels.type_voie">
                                        <el-select
                                                :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                                clearable
                                                filterable
                                                v-model="post.type_voie"
                                        >
                                            <el-option
                                                    :key="typeVoieChoice"
                                                    :label="typeVoieChoice"
                                                    :value="typeVoieChoice"
                                                    style="text-transform:capitalize"
                                                    v-for="typeVoieChoice in this.getChoices('type_voie')"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :md="12" :xs="24">
                                    <el-form-item :label="$t('posts.edit.address')">
                                        <el-input v-model="post.nom_voie"></el-input>
                                    </el-form-item>
                                </el-col>
                            </div>
                            <div v-else>
                                <el-col :md="18" :xs="24">
                                    <el-form-item :label="$t('posts.edit.address')">
                                        <el-input v-model="post.nom_voie"></el-input>
                                    </el-form-item>
                                </el-col>
                            </div>
                            <el-col :md="24" :xs="24">
                              <el-form-item :label="$labels.quartier">
                                <el-input v-model="post.quartier"></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :md="24" :xs="24">
                                <el-form-item :label="$labels.adresse2">
                                    <el-input :rows="5" type="textarea" v-model="post.adresse2"></el-input>
                                </el-form-item>
                            </el-col>
                            <div v-if="isARLOGIS">
                                <el-col :md="12" :xs="12">
                                    <el-form-item :label="$labels.latitude">
                                        <el-input v-model="post.latitude"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :md="12" :xs="12">
                                    <el-form-item :label="$labels.longitude">
                                        <el-input  v-model="post.longitude"></el-input>
                                    </el-form-item>
                                </el-col>
                            </div>
                            <el-col :span="24" v-if="isPromoteur">
                                <el-form-item :label="$labels.bureau_vente_adresse">
                                    <el-input :rows="5" type="textarea" v-model="post.bureau_vente_adresse"></el-input>
                                </el-form-item>
                            </el-col>
                            <!--							<el-col :span="12" v-if="isCmiste == false">-->
                            <el-col :span="12">
                                <el-form-item :label="$labels.communiquer_adresse_exacte + ' *'" prop="communiquer_adresse_exacte">
                                    <el-radio-group v-model="post.communiquer_adresse_exacte" >
                                        <el-radio label="oui" value="oui">{{ $t("general.yes") }}</el-radio>
                                        <el-radio label="non" value="non">{{ $t("general.no") }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>

                            <!--							<el-col :span="12" v-if="isCmiste == false">-->
                            <el-col :span="12">
                                <el-col :span="12">
                                    <el-tooltip placement="top-start" :content="$t('posts.edit.exactAddressTooltip')">
                                        <em class="el-icon-question"></em>
                                    </el-tooltip>
                                </el-col>
                            </el-col>
                        </el-row>

                        <!--						<div v-if="post.communiquer_adresse_exacte === 'non' || isCmiste">-->
                        <div v-if="post.communiquer_adresse_exacte === 'non'">
                            <el-col :span="24">
                                <hr/>
                            </el-col>
                            <el-row v-if="isCmiste">
                                <el-col :span="8">
                                    <h4>{{ $t("posts.edit.locationToPublishTitle") }}
                                        <el-tooltip placement="top-start" :content="$t('posts.edit.locationToPublishTooltip')">
                                            <em class="el-icon-question"></em>
                                        </el-tooltip></h4>
                                    <br>
                                </el-col>
                            </el-row>
                            <el-row v-else>
                                <el-col :span="24">
                                    <h4>{{ $t("posts.edit.locationToPublishTitle") }}</h4>
                                    <br>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :md="12" :xs="24">
                                    <el-form-item :label="$labels.code_postal + ' *'" prop="code_postal">
                                        <el-autocomplete
                                                class="inline-input"
                                                v-model="post.code_postal"
                                                :fetch-suggestions="searchPostal"
                                                @select="selectPostal"></el-autocomplete>
                                    </el-form-item>
                                </el-col>
                                <el-col :md="12" :xs="24">
                                    <el-form-item :label="$labels.ville + ' *'" prop="ville">
                                        <el-input v-model="post.ville"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :md="24" :xs="24">
                                    <el-form-item label="Secteur" prop="secteur">
                                        <el-input v-model="post.zone_geo"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </el-main>
                </el-container>
            </ubi-panel>
        </div>

        <div v-show="currentTab === 'detail'">
            <component :ddList.sync="ddList" @ddList-update="ddListUpdated" :is="selectTypeOffreComponent()" :post="post"/>
            <LabelsAndCertifications :post="post" v-if="post.typeObjet == 5200"/>
        </div>

        <div v-show="currentTab === 'description'">
            <component :ddList.sync="ddList" @ddList-update="ddListUpdated" :is="selectTypeObjetComponent()" :post="post"/>
        </div>

        <div v-show="currentTab === 'medias'">
            <ubi-panel>
                <PostFormGroupPhotos/>
                <PostImagesUpload :post="post" :desactiverChamp="desactiverChamp"/>
            </ubi-panel>

            <PostOtherMediaUpload :post="post" :desactiverChamp="desactiverChamp"/>

        </div>

        <div v-show="currentTab === 'mentions_legales'">
            <PostFormMentionsLegalesSelect :post="post"/>
        </div>

        <div v-show="currentTab === 'international'">
            <ubi-panel>
                <ubi-form-group :title="$t('posts.edit.internationalTitle')">
                    <el-col :span="24">
                        <el-form-item :label="$labels.titre_anglais">
                            <el-input v-model="post.titre_anglais"/>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item :label="$labels.texte_anglais">
                            <el-input :rows="5" type="textarea" v-model="post.texte_anglais"/>
                        </el-form-item>
                    </el-col>
                </ubi-form-group>
            </ubi-panel>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import UbiPanel from '@/components/Panel'
import UbiCardContainer from '@/components/CardContainer'
import UbiCard from '@/components/Card'
import PostFormObjectType from '../components/PostFormObjectType'
import PostFormOfferType from '../components/PostFormOfferType'
import PostFormGroupPhotos from '../components/PostFormGroupPhotos'
import PostImagesUpload from '../components/PostImagesUpload'
import PostEditImmoObject1200CmiModel from '../forms/immo/PostEditImmoObject1200CmiModel'
import PostEditImmoObject1310CmiModel from '../forms/immo/PostEditImmoObject1310CmiModel'
import PostEditImmoOfferA from '../forms/immo/PostEditImmoOfferA'
import PostEditImmoOfferB from '../forms/immo/PostEditImmoOfferB'
import PostEditImmoOfferF from '../forms/immo/PostEditImmoOfferF'
import PostEditImmoOfferG from '../forms/immo/PostEditImmoOfferG'
import PostEditImmoOfferH from '../forms/immo/PostEditImmoOfferH'
import PostEditImmoOfferI from '../forms/immo/PostEditImmoOfferI'
import PostEditImmoOfferL from '../forms/immo/PostEditImmoOfferL'
import PostEditImmoOfferM from '../forms/immo/PostEditImmoOfferM'
import PostEditImmoOfferS from '../forms/immo/PostEditImmoOfferS'
import PostEditImmoOfferV from '../forms/immo/PostEditImmoOfferV'
import PostEditImmoOfferW from '../forms/immo/PostEditImmoOfferW'
import PostEditImmoOfferZ from '../forms/immo/PostEditImmoOfferZ'
import PostFormMentionsLegalesSelect from '../forms/immo/PostFormMentionsLegalesSelect'
import PostFormMentionsLegalesCreate from '../forms/immo/PostFormMentionsLegalesCreate'
import PostFormMentionsLegalesManage from '../forms/immo/PostFormMentionsLegalesManage'
import ElButton from '../../../components/Button'
import { getCodePostalVille } from '@/services/toolbox'
import PostOtherMediaUpload from '../components/PostOtherMediaUpload'
import _find from 'lodash/find'
import PostFormContactInfo from '../components/PostFormContactInfo'
import PostFormAttachedUser from '../components/PostFormAttachedUser'
import LabelsAndCertifications from '@/pages/posts/forms/Block/LabelsAndCertifications.vue'
import { getFromSnake } from '@/helpers/functions/getFromSnake'

export default {
  name: 'PostEditImmo',
  props: ['currentTab', 'create', 'post'],
  // DO NOT FORGET TO REGISTERS OBJECT AND OFFER COMPONENTS, OTHERWHISE THIS WILL NOT WORK
  components: {
    PostOtherMediaUpload,
    ElButton,
    PostEditImmoObject1310CmiModel,
    PostEditImmoObject1200CmiModel,
    PostEditImmoOfferA,
    PostEditImmoOfferB,
    PostEditImmoOfferF,
    PostEditImmoOfferG,
    PostEditImmoOfferH,
    PostEditImmoOfferI,
    PostEditImmoOfferL,
    PostEditImmoOfferM,
    PostEditImmoOfferS,
    PostEditImmoOfferV,
    PostEditImmoOfferW,
    PostEditImmoOfferZ,
    PostImagesUpload,
    PostFormGroupPhotos,
    PostFormOfferType,
    PostFormObjectType,
    UbiCard,
    UbiCardContainer,
    UbiPanel,
    PostFormMentionsLegalesCreate,
    PostFormMentionsLegalesManage,
    PostFormMentionsLegalesSelect,
    PostFormContactInfo,
    PostFormAttachedUser,
    LabelsAndCertifications
  },
  inject: ['browserContext'],

  data () {
    return {
      choixCommercialisation: '',
      tabs: [
        { name: 'main', title: this.$t('posts.edit.tabMain') },
        { name: 'description', title: this.$t('posts.edit.tabDescription'), disabled: false },
        { name: 'medias', title: this.$t('posts.edit.tabMedias') },
        { name: 'mentions_legales', title: this.$t('posts.edit.tabLegalNotices') },
        { name: 'international', title: this.$t('posts.edit.tabInternational') }
      ],
      nomProgram: '',
      ddList: [],
      parent: null,
      codesPostaux: [],
      paysValue: null,
      desactiverChamp: true,
      checkedList: [],
      valueChange: '',
      valueDevise: '',
      chargementDonnees: true
    }
  },
  methods: {
    ...mapMutations('posts', ['setTabs']),
    changeCheckboxLot (val) {
      this.valueChange = val
      if (this.post[val] == 'oui') {
        this.checkedList[val] = true
      } else {
        this.checkedList[val] = false
      }
    },
    changeForLot (val) {
      this.valueChange = this.post[val]
    },
    selectTypeObjetComponent () {
      if (this.post.typeObjet) {
        let formToCall = 0
        if (this.post.typeObjet >= 1200 && this.post.typeObjet < 1300) {
          formToCall = 1200
        } else if (this.post.typeObjet >= 1300 && this.post.typeObjet < 1400) {
          formToCall = 1310
        } else {
          formToCall = this.post.typeObjet
        }
        const component =
                        'PostEditImmoObject' + Math.trunc(formToCall) + 'CmiModel'
        if (this.$options.components[component]) {
          return component
        }
      }
      return null
    },
    async searchPostal (queryString, cb) {
      const results = await getCodePostalVille(queryString, this.post.pays)
      if (results.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      const tab = Object.values(results.result)
      cb(tab)
    },
    selectPays (item) {
      this.post.pays = item
    },
    selectPostal (item) {
      this.post.ville = item.ville
      this.post.code_postal = getFromSnake(item, 'code_postal')
    },
    selectPostalInternet (item) {
      this.post.ville_contact_a_afficher = item.ville
      this.post.code_postal_contact_a_afficher = getFromSnake(item, 'code_postal')
    },
    selectPostalProprietaire (item) {
      this.post.proprietaire_ville = item.ville
      this.post.proprietaire_code_postal = getFromSnake(item, 'code_postal')
    },
    selectPostalReel (item) {
      this.post.ville_reelle = item.ville
      this.post.code_postal_reel = getFromSnake(item, 'code_postal')
    },
    selectTypeOffreComponent () {
      if (this.post.typeOffre) {
        const component = 'PostEditImmoOffer' + this.post.typeOffre
        if (this.$options.components[component]) {
          return component
        } else {
          this.tabs[1].disabled = true
        }
      }
      return null
    },
    getChoices (code) {
      if (!this.ddList.length) return []
      const dd = this.ddList.find(x => x.code === code.toUpperCase())
      if (dd) {
        return dd.values
      }
      return []
    },
    chargerPays () {
      if (!this.post.pays) {
        if (this.sitimmoUser.pays) {
          this.paysValue = this.sitimmoUser.pays
        } else {
          this.paysValue = 'France'
        }
      } else {
        this.paysValue = this.post.pays
      }
    },
    ddListUpdated (ddList) {
      ddList.forEach(function (item) {
        if (!_find(this.ddList, { code: item.code })) {
          this.ddList.push(item)
        }
      }, this)
    },
    TVA (taux) {
      if (taux == 'TVA_7' && this.post.TVA_7 == 'oui') {
        this.post.taux_tva = 7
        this.post.TVA_55 = null
      } else if (taux == 'TVA_55' && this.post.TVA_55 == 'oui') {
        this.post.taux_tva = 5.5
        this.post.TVA_7 = null
      } else {
        this.post.taux_tva = null
        this.post.TVA_7 = null
        this.post.TVA_55 = null
      }
    },
    chargementValue () {
      if (!this.create && this.chargementDonnees) {
        if (this.post.ville_reelle || this.post.ville) {
          if (this.post && !this.post.ville_reelle && this.post.ville) {
            this.post.ville_reelle = this.post.ville
          }
          if (this.post && !this.post.code_postal_reel && this.post.code_postal) {
            this.post.code_postal_reel = this.post.code_postal
          }
          this.chargementDonnees = false
        }
      }
    },
    deviseSelect (value) {
      this.valueDevise = value
      this.$store.commit('donnees/SET_DEVISE', this.post.devise_iso_4217)
      return value
    }
  },
  computed: {
    ...mapState('postsListImmo', ['filter', 'results']),
    ...mapGetters(['getCountries']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    isARLOGIS () {
      return this.sitimmoUser.reseau === 'ARLOGIS'
    },
    isChecked () {
      const val = this.valueChange
      this.valueChange = ''
      return this.checkedList[val]
    },
    getDevise () {
      return this.$store.getters['donnees/getDevise']
    }
  },
  async beforeMount () {
    this.currentType = this.$route.params.type
    if (this.currentType == 'terrain') {
      this.post.typeObjet = 1310
      this.$route.meta.title = this.$t('posts.edit.createLand')
    }
    if (this.currentType == 'modele') {
      this.post.typeObjet = 1200
      this.$route.meta.title = this.$t('posts.list.createModel')
    }

    this.setTabs(this.tabs)
    this.chargerPays()
    let codes = [
      'mitoyennete',
      'style_construction',
      'garage_emplacement',
      'type_cuisine',
      'type_construction',
      'type_livraison',
      'eau_chaude_distribution',
      'chauffage_energie',
      'chauffage_type',
      'vitrages',
      'type_stationnement',
      'type_jardin',
      'grenier',
      'revetement_sol_principal',
      'exposition',
      'environnement',
      'standing',
      'dpe_etiquette_conso',
      'dpe_etiquette_ges',
      'residence_type',
      'type_voie',
      'devise_iso_4217'
    ]
    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    this.ddList = await getDefinitionDonneeListeeByCode({ codes: codes })
  },
  async mounted () {
    // Cas d'un lot en création d'annonce
    if (!this.post.devise_iso_4217) {
      this.post.devise_iso_4217 = 'EUR'
    }
    this.desactiverChamp = false
  }
}
</script>

<style>
    .el-option__label::first-letter {
        text-transform: uppercase;
    }
    .el-radio__label::first-letter {
        text-transform: uppercase;
    }
    .el-checkbox__label::first-letter {
        text-transform: uppercase;
    }

    .red {
        color: red;
    }
</style>
